import React from "react";
import { IMG } from "../../../assets";
import LoginForm from "./LoginForm";

export default function Login() {
  return (
    <div className="flex flex-row w-full md:h-screen items-center">
      <div className="py-12 flex-1">
        <div className="flex rounded-lg shadow-2xl overflow-hidden mx-auto max-w-sm lg:max-w-4xl">
          <div className="hidden lg:block lg:w-1/2">
            <img
              src={IMG.login}
              // src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Mahindra_Thar_Photoshoot_At_Perupalem_Beach_%28West_Godavari_District%2CAP%2CIndia_%29_Djdavid.jpg/800px-Mahindra_Thar_Photoshoot_At_Perupalem_Beach_%28West_Godavari_District%2CAP%2CIndia_%29_Djdavid.jpg"
              className="w-full h-full object-cover"
              alt="logo"
            />
          </div>
          <div className="w-full p-8 lg:w-1/2">
            <h2 className="text-2xl font-semibold text-primary text-center">
              ENCORE
            </h2>
            <div className="bg-gray flex items-center justify-center mt-4 text-black rounded-lg shadow-md hover:bg-white">
              <h1 className="px-4 py-3 w-5/6 text-center text-gray-600 font-bold">
                Events & Entertainment
              </h1>
            </div>
            <div className="mt-4 flex items-center justify-between">
              <span className="border-b border-primary w-1/5 lg:w-1/4"></span>
              <div
                href="#"
                className="text-xs text-center text-grey-500 uppercase"
              >
                Admin Login
              </div>
              <span className="border-b w-1/5 border-primary lg:w-1/4"></span>
            </div>
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
}
